module.exports = __webpack_public_path__ + "img/school_xazz.32945141.png";